var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"dropbox",class:{
  'dropbox--fixed': _vm.mode === _vm.DropboxMode.Fixed,
  'dropbox--hidden': _vm.is_hidden
},style:(_vm.style)},_vm._l((_vm.options),function(option,i){return _c('div',{key:i,staticClass:"dropbox__option",class:{
    'dropbox__option--selected': _vm.selected.includes(i)
  },attrs:{"value":option.value},on:{"click":function($event){return _vm.onOptionSelected(i, option)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }